<template>
  <v-form ref="form" flat class="pt-5">
    <v-row>
      <v-col cols="12">
        <DateIOSPicker
          label="Ngày"
          :date.sync="time"
          outlined
          class="required"
          :rules="[$rules.required, $rules.date, $rules.dateFromNow]"
          dense
        />
      </v-col>
      <v-col cols="12">
        <GradeClassStudentSelect
          :gradeCol="{ cols: 12, md: 6 }"
          :classCol="{ cols: 12, md: 6 }"
          :studentCol="{ cols: 12 }"
          :gradeRules="[$rules.required]"
          :classRules="[$rules.required]"
          :studentRules="[$rules.required]"
          @changed="gradeClassStudentChange"
          class="required"
        />
      </v-col>
      <!-- <v-col cols="12">
        <AutocompleteSubject
          v-model="selectedSubject"
          return-object
          label="Tiết học"
          hide-details="auto"
          outlined
          dense
          clearable
          :filter="filterSubject"
        />
      </v-col> -->
      <v-col cols="12">
        <RadioViolation :violation.sync="type" @change="type = $event" mandatory />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="description"
          label="Nội dung"
          class="required"
          :rules="[$rules.required]"
          hide-details="auto"
          outlined
          dense
        ></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import get from 'lodash-es/get'
import moment from 'moment'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject.vue'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import RadioViolation from './RadioViolation.vue'

export default {
  components: {
    GradeClassStudentSelect,
    AutocompleteSubject,
    DateIOSPicker,
    RadioViolation
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    selectedSubject: {},
    description: '',
    type: '',
    time: moment().toISOString()
  }),
  computed: {
    ...mapState('app', ['currentSemester']),
    filterSubject() {
      return { grade: get(this.selectedGrade, 'id', '') }
    }
  },
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
      this.selectedStudent = data.student
    },
    reset() {
      this.selectedGrade = null
      this.selectedClass = null
      this.selectedStudent = null
      this.selectedSubject = null
      this.description = null
      this.time = moment().toISOString()
      this.type = 'commendation'

      this.$refs.form.resetValidation()
    },
    validate() {
      return this.$refs.form.validate()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      if (this.$refs.form.validate()) {
        const data = {
          grade: get(this.selectedGrade, 'id', ''),
          classData: get(this.selectedClass, 'id', ''),
          student: get(this.selectedStudent, 'id', ''),
          // subject: this.selectedSubject ? get(this.selectedSubject, 'id', '') : null,
          description: this.description,
          type: this.type,
          date: this.time,
          semester: this.currentSemester.id
        }
        return data
      }
    },
    resetDefault() {
      if (this.violation) {
        this.selectedGrade = this.violation.grade
        this.selectedClass = this.violation.classData
        this.selectedStudent = this.violation.student
        this.selectedSubject = this.violation.subject
        this.description = this.violation.description
        this.type = this.violation.type
        this.data = this.violation.data
      } else {
        this.reset()
      }
    }
  }
}
</script>
